import React from 'react';
import strings from './strings.js'
import icoLightGray from './img/ico-light-gray.png'
import icoLightGreen from './img/ico-light-green.png'
import { useNavigate } from 'react-router-dom';
import { SendMessage } from './App.js';
import useSongSearch from './useSongSearch.js';
import {useState} from 'react';
import icoDel from './img/ico-del.svg';
import icoInsert from './img/insert.svg';
import icoInsertEmpty from './img/insertEmpty.svg';
import icoPlay from './img/ico-playOverview.svg';
import icoMute from './img/ico-mute.svg';
import icoUnmute from './img/ico-unmute.svg';
import icoA from './img/ico-a.svg';
import icoD from './img/ico-d.svg';

const API_URL = "https://www.starboxkod.com/api";

const TableCard = ({ tableName, lang, table, onClick, setTableNo, setSelectingQuotaTable, setSelectingQuotaIndex, setSelectingQuotaNumber } ) => {



    const navigate = useNavigate()

    const [pageNumber, setPageNumber] = useState(0);

    const {
        loading,
        error,
        songs,
        hasMore
    } = useSongSearch(table.playlist.map(f=> f.songcode).toString(), pageNumber)

    const lookup = Object.fromEntries(songs.map(o => [o.song_num, o]));

    lookup["1111"] = {
        "song_num": null,
        "song_name": "YOUTUBE",
        "singer": "YOUTUBE",
        "singer2": null,
        "singer3": null,
        "language": null,
        "server_id": "null",
        "rel_path": "null",
        "audio_track": 1
    };
    //ffb8d1
    //ffcc99 fff2e6
    return (
    <>
        <div className="tableMgmtItem" style={{backgroundColor: table.locked ? "#d9d9d9": "#ffa799"}}> 
            <div className="tableMgmtName">{tableName.toUpperCase()}</div>

            <div className="tableMgmtIcon"
                onClick={(e) => {e.preventDefault();
                }}
            >
                {table.playing ? <img src={icoPlay}/> : "" }
            </div>


            <div className="tableMgmtIcon"
                onClick={(e) => {e.preventDefault();
                if (table.locked) {
                    SendMessage(`[{"type":"HALL_SET_LOCK","tableId":"${tableName}","locked":false}]`);
                } else {
                    SendMessage(`[{"type":"HALL_SET_LOCK","tableId":"${tableName}","locked":true}]`);
                }
                }}
            ><img src={table.locked ? icoLightGray : icoLightGreen}/>
            </div>


        
            <div className="tableMgmtQuota"
                onClick={(e) => {e.preventDefault(); if(table.locked) {return;} setSelectingQuotaTable(tableName); setSelectingQuotaNumber(table.quota); navigate("quota");}}
            >{table.quota}</div>

            
            

            <div className="tableMgmtButton"  style={{backgroundColor: table.locked ? "#f3f3f3": "#ffe9e6", marginLeft: "3vw"}}
                onClick={(e) => {e.preventDefault(); setSelectingQuotaTable(tableName); navigate("all");}}
            >{lang ? strings.cn.all : strings.en.all}</div>

            <div className="tableMgmtButton"  style={{backgroundColor: table.locked ? "#f3f3f3": "#ffe9e6"}}
                onClick={(e) => {e.preventDefault(); if(table.locked) {return;} setTableNo(parseInt(tableName.substring(1))); navigate("/admin/songs")}}
            >{lang ? strings.cn.add : strings.en.add}</div>
        </div>
        
        
        {!loading && table.playlist.map(f => f.songcode).toString() !== "" ? (
    <>
        {table.playlist.map((f, index) => {
            const song_num = f.songcode;
            if (lookup[song_num] != null) {
                if (song_num === "1111") {
                    lookup["1111"] = {
                        "song_num": null,
                        "song_name": table.playlist.map(f => f.ytname)[index].substring(0, 20),
                        "singer": "YOUTUBE",
                        "singer2": null,
                        "singer3": null,
                        "language": null,
                        "server_id": "null",
                        "rel_path": "null",
                        "audio_track": 1
                    };
                }
                return (
                    <div key={index}>
                        <div style={{ display: 'flex', marginTop: "0.75vh", marginBottom: "0.75vh" }}>
                            <div style={{ flex:"0.5", flexBasis: "7vw", textAlign: 'left', textOverflow: "clip" }} className="overview-container-selected">
                                {lookup[song_num].song_name} - {lookup[song_num].singer} {lookup[song_num].singer2 && `, ${lookup[song_num].singer2}`} {lookup[song_num].singer3 && `, ${lookup[song_num].singer3}`}
                            </div>

                            {song_num === "1111" ? (
                                <a className="adminKeyandDigital" style={{ flex:"0.1",flexBasis: "7vw", height: "auto", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={(e) => { e.preventDefault(); }}>
                                    &nbsp;
                                </a>
                            ) : (
                                <a className="adminKeyandDigital" style={{ flex:"0.1",flexBasis: "7vw", height: "auto", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={(e) => { e.preventDefault(); setSelectingQuotaTable(tableName); setSelectingQuotaIndex(index); setSelectingQuotaNumber(f.musicKey); navigate("key"); }}>
                                     {(f.musicKey<1?"":"+")}{f.musicKey}
                                </a>
                            )}

                            {song_num === "1111" ? (
                                <a className="adminKeyandDigital" style={{ flex:"0.1",flexBasis: "7vw", height: "auto", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={(e) => { e.preventDefault(); }}>
                                    &nbsp;
                                </a>
                            ) : (
                                <a className="adminKeyandDigital" style={{ flex:"0.1",flexBasis: "7vw", height: "auto", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={(e) => { e.preventDefault(); SendMessage(`[{"type":"HALL_VOCAL_SONG","tableId":"${tableName}","index":${index},"vocal":${!f.vocal}}]`); }}>
                                    {f.vocal ? "A" : "D"}
                                </a>
                            )}

                            {song_num === "1111" ? (
                                <a style={{ flex:"0.1",flexBasis: "7vw", height: "auto", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={(e) => { e.preventDefault(); }}>
                                    <img src='data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=' alt="ListDelete" style={{ height: "20px" }} />
                                </a>
                            ) : (
                                <a style={{flex:"0.1", flexBasis: "7vw", height: "auto", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={(e) => { e.preventDefault(); SendMessage(`[{"type":"HALL_REC_SONG","tableId":"${tableName}","index":${index},"rec":${!f.rec}}]`); }}>
                                    <img src={f.rec ? icoUnmute : icoMute} alt="ListDelete" style={{ height: "20px" }} />
                                </a>
                            )}

                            {index === 0 ? (
                                <a alt="Insert" style={{ flex:"0.1",flexBasis: "7vw", height: "auto", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={(e) => { e.preventDefault(); }}>
                                    <img src={icoInsertEmpty} alt="ListInsert" style={{ height: "20px" }} />
                                </a>
                            ) : (
                                <a alt="Insert" style={{flex:"0.1", flexBasis: "7vw", height: "auto", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={(e) => { e.preventDefault(); SendMessage(`[{"type":"HALL_INSERT_SONG","tableId":"${tableName}","index":${index}}]`); }}>
                                    <img src={icoInsert} alt="ListInsert" style={{ height: "20px" }} />
                                </a>
                            )}

                            <a style={{ flex:"0.1",flexBasis: "7vw", height: "auto", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={(e) => { e.preventDefault(); console.log(`[{"type":"HALL_DELETE_SONG","tableId":"${tableName}","index":${index}}]`); SendMessage(`[{"type":"HALL_DELETE_SONG","tableId":"${tableName}","index":${index}}]`); }}>
                                <img src={icoDel} alt="ListDelete" style={{ height: "20px" }} />
                            </a>
                        </div>
                    </div>

                );
            }
        })}
    </>
) : (
    <></>
)}

    </>
    );
}

export default TableCard;